import { Badge, DropdownMenuItem } from "web-design-system";
import { getCORSSafeURL } from "@/utils/url";
import AppLogo from "../logo/app-logo";

type PartnerAccountSettingsSectionProps = {
  organizationLine: string;
  roleLabel: string;
  brandingLogo?: string | null;
  onOpenAccountSettings: () => void;
};

export function PartnerAccountSettingsSection({
  organizationLine,
  roleLabel,
  brandingLogo,
  onOpenAccountSettings,
}: PartnerAccountSettingsSectionProps) {
  return (
    <div className="flex flex-col items-center gap-4 border-b border-border px-4 py-5 text-center">
      <div className="flex flex-col items-center gap-3">
        <div className="shrink-0 overflow-hidden rounded-lg bg-muted">
          {brandingLogo ? (
            <img
              crossOrigin="anonymous"
              src={getCORSSafeURL(brandingLogo)}
              alt={organizationLine || "Brand logo"}
              width={36}
              height={36}
              className="object-cover"
            />
          ) : (
            <div className="flex size-full items-center justify-center">
              <AppLogo width={36} height={36} />
            </div>
          )}
        </div>
        <p className="line-clamp-2 w-full text-sm font-semibold text-foreground">
          {organizationLine}
        </p>
        <Badge variant="custom" className="rounded-sm bg-slate-700 text-white">
          {roleLabel}
        </Badge>
      </div>
      <DropdownMenuItem
        className="cursor-pointer rounded-md border border-border bg-background shadow-xs"
        onClick={onOpenAccountSettings}
      >
        Account Settings
      </DropdownMenuItem>
    </div>
  );
}
